/** Central query keys so mutations can invalidate precisely. */
export const qk = {
  me: ['me'] as const,
  lookups: (kind: 'sources' | 'products' | 'users' | 'lists') => ['lookups', kind] as const,
  customers: (params: unknown) => ['customers', 'list', params] as const,
  customersAll: ['customers'] as const,
  customer: (id: string) => ['customers', 'detail', id] as const,
  duplicates: (params: unknown) => ['customers', 'duplicates', params] as const,
  mergePreview: (a: string, b: string) => ['customers', 'merge', a, b] as const,
  leadsSummary: ['leads', 'summary'] as const,
  leads: (params: unknown) => ['leads', 'list', params] as const,
  leadsAll: ['leads'] as const,
  tasks: (params: unknown) => ['tasks', params] as const,
  tasksAll: ['tasks'] as const,
  notifications: ['notifications'] as const,
  views: (screen: string) => ['views', screen] as const,
  adminUsers: ['admin', 'users'] as const,
  adminRoles: ['admin', 'roles'] as const,
  adminPermissions: ['admin', 'permissions'] as const,
  adminTeams: ['admin', 'teams'] as const,
  adminAgents: ['admin', 'agents'] as const,
  adminAbsences: (userId: string) => ['admin', 'absences', userId] as const,
  adminCalendar: ['admin', 'calendar'] as const,
  adminSettings: ['admin', 'settings'] as const,
  adminAudit: (params: unknown) => ['admin', 'audit', params] as const,
  adminLogins: ['admin', 'logins'] as const,
};
